import { useState, useEffect, useCallback } from 'react';
import GeneroContext from './GeneroContext';
import Formulario from './FormularioGenero';
import Tabela from './TabelaGenero';
import Carregando from '../../comuns/Carregando';
import WithAuth from "../../../seguranca/WithAuth";
import { useNavigate } from "react-router-dom";

import {
    getGenerosAPI,
    getGeneroPorIdAPI,
    deleteGeneroPorIdAPI,
    cadastraGeneroAPI
} from '../../../servicos/GeneroServicos';

function Genero() {

    const navigate = useNavigate();

    const [alerta, setAlerta] = useState({ status: "", message: "" });
    const [listaObjetos, setListaObjetos] = useState([]);
    const [carregando, setCarregando] = useState(true);

    const [editar, setEditar] = useState(false);
    const [exibirForm, setExibirForm] = useState(false);

    const [objeto, setObjeto] = useState({
        id_genero: "",
        descricao: ""
    });

    // =========================
    // LISTAR
    // =========================

    const recuperaGeneros = useCallback(async () => {
        try {
            setCarregando(true);

            const dados = await getGenerosAPI();
            setListaObjetos(dados);

        } catch (err) {
            console.error("Erro ao recuperar gêneros:", err);
            navigate("/login", { replace: true });
        } finally {
            setCarregando(false);
        }
    }, [navigate]);

    // =========================
    // REMOVER
    // =========================

    const remover = async (id) => {
        if (window.confirm('Deseja remover este objeto?')) {
            try {
                let retornoAPI = await deleteGeneroPorIdAPI(id);

                setAlerta({
                    status: retornoAPI.status,
                    message: retornoAPI.message
                });

                recuperaGeneros();

            } catch (err) {
                console.error("Erro ao remover gênero:", err);
                navigate("/login", { replace: true });
            }
        }
    };

    // =========================
    // NOVO
    // =========================

    const novoObjeto = () => {
        setEditar(false);
        setAlerta({ status: "", message: "" });

        setObjeto({
            id_genero: 0,
            descricao: ""
        });

        setExibirForm(true);
    };

    // =========================
    // EDITAR
    // =========================

    const editarObjeto = async (id) => {
        try {
            const resposta = await getGeneroPorIdAPI(id);

            const dados = resposta?.objeto || resposta?.[0] || resposta;

            if (!dados) return;

            setObjeto({
                id_genero: dados.id_genero || 0,
                descricao: dados.descricao || ""
            });

            setEditar(true);
            setExibirForm(true);

        } catch (err) {
            console.error("Erro ao editar gênero:", err);
            navigate("/login", { replace: true });
        }
    };

    // =========================
    // CADASTRAR / ALTERAR
    // =========================

    const acaoCadastrar = async (e) => {
        e.preventDefault();

        const metodo = editar ? "PUT" : "POST";

        try {
            let retornoAPI = await cadastraGeneroAPI(objeto, metodo);

            setAlerta({
                status: retornoAPI.status,
                message: retornoAPI.message
            });

            setExibirForm(false);

            recuperaGeneros();

        } catch (err) {
            console.error("Erro ao cadastrar/alterar gênero:", err);
            navigate("/login", { replace: true });
        }
    };

    // =========================
    // CHANGE FORM
    // =========================

    const handleChange = (e) => {
        const { name, value } = e.target;

        setObjeto({
            ...objeto,
            [name]: value
        });
    };

    // =========================
    // LOAD INICIAL
    // =========================

    useEffect(() => {
        recuperaGeneros();
    }, [recuperaGeneros]);

    // =========================
    // RENDER
    // =========================

    return (
        <GeneroContext.Provider
            value={{
                listaObjetos,
                alerta,
                remover,
                objeto,
                editarObjeto,
                acaoCadastrar,
                handleChange,
                novoObjeto,
                exibirForm,
                editar,
                setExibirForm
            }}
        >
            <Formulario />

            <Carregando carregando={carregando}>
                <Tabela />
            </Carregando>
        </GeneroContext.Provider>
    );
}

export default WithAuth(Genero);